/**
 * @desc 获取库存锁定明细
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderPackage.getLockStockDetail.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/systemOrderPackage/getLockStockDetail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
